(function ($) {
    var CONTAINER_SIZE_LG = 1100;

    var $header = $('.page-header');
    var $mainNav = $header.find('.js-main-navigation');
    var $searchBox = $header.find('.js-search-box');
    var $searchBoxButton = $searchBox.find('.js-search-box-submit');
    var $searchBoxInput = $searchBox.find('.js-search-box-input');

    $searchBoxButton.click(function (e) {
        if ($searchBox.is('.search-box-expandable') && !$searchBox.is('.expanded')) {
            e.preventDefault();

            $mainNav.stop().hide();

            $searchBox.addClass('expanded');
            $searchBoxInput.fadeIn();
            $searchBoxInput.focus();

            $searchBoxInput.one('blur', function () {
                setTimeout(function () {
                    $searchBox.removeClass('expanded');
                    $searchBoxInput.stop().hide();
                    $mainNav.fadeIn();
                }, 100);
            });
        }
    });
/*
    var evaluateSearchBoxClasses = function () {
        var containerWidth = $('.container:first').width();

        if (containerWidth < CONTAINER_SIZE_LG) {
            $searchBox.addClass('search-box--expandable');
        } else {
            $searchBox.removeClass('search-box--expandable');
        }
    }

    $(document).ready(evaluateSearchBoxClasses);
    $(window).load(evaluateSearchBoxClasses);
    $(window).resize(evaluateSearchBoxClasses);*/
})(jQuery);